import def from "csi/def";
import declare from "dojo/_base/declare";
import { registerActionClass } from "csi/def/ActionFactory";
import _StateAction from "./_StateAction";

const ReviseAndAbandon = declare(_StateAction, {
	_bLatestRevision: false,
	m_tag: "ReviseAndAbandon",

	constructor(obj: Element) {
		if (!this.m_typeControl) {
			this.m_typeControl = def.ACTION_ICON;
			this.m_class = "iconRevise " + (this.m_class || "");
		}
	},
});

registerActionClass("ReviseAndAbandon", ReviseAndAbandon);

export = ReviseAndAbandon;